import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";
import { DownloadLargeIcon } from "../../../../components/icons";


export const NaritaAirport = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const location = useLocation();
  const history = useHistory();

  const terminals = [
    {
      id: "1",
      imageUrl: t("MapPage.NaritaAirport.NaritaAirportImageUrl1")
    },
    {
      id: "2",
      imageUrl: t("MapPage.NaritaAirport.NaritaAirportImageUrl2")
    },
    {
      id: "3",
      imageUrl: t("MapPage.NaritaAirport.NaritaAirportImageUrl3")
    },
  ];

  const [activeTab, setActiveTab] = useState(terminals[0].id);

  const setTerminal = (terminalId) => {
    const params = new URLSearchParams(location.search);
    params.set("t", terminalId);
    history.push({ search: `?${params.toString()}` });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    let terminalParam = searchParams.get("t");
    if (!terminalParam && searchParams.get("type") === "narita-airport") {
      setTerminal("1");
      return;
    }
    const matchedTerminal = terminals.find((tab) => tab.id === terminalParam);
    const nextActiveTab = matchedTerminal ? matchedTerminal.id : "1";

    setActiveTab((prev) => (prev === nextActiveTab ? prev : nextActiveTab));
  }, [location.search, terminals]);

  return (
    <div>
      <div className="tw:hidden tw:lg:rounded-md tw:lg:flex tw:justify-between tw:items-start tw:lg:items-center">
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:overflow-hidden tw:border-t tw:border-r tw:border-[#DADADA] tw:rounded-md tw:relative tw:w-full">
          <div className="tw:lg:min-w-[320px] tw:relative">
            <div
              className={cn(
                "tw:flex tw:items-center tw:px-[26px] tw:cursor-pointer tw:h-[75px] tw:relative",
                activeTab === "1" ? "tw:bg-white tw:font-semibold tw:border-b tw:border-l tw:border-[#DADADA] tw:z-[2] tw:rounded-tl-md tw:border-l" : "tw:border-[#DADADA] tw:bg-[#F7F7F7]",

              )}
              onClick={() => setTerminal("1")}
            >
              <div
                className={cn(
                  activeTab === "1" ? "tw:text-[#282828]" : "tw:text-[#8D8D8D]"
                )}
              >
                {t("MapPage.NaritaAirport.Terminal1")}
              </div>
            </div>
            <div
              className={cn(
                "tw:flex tw:items-center tw:px-[26px] tw:cursor-pointer tw:h-[75px] tw:relative tw:rounded-bl-md",
                activeTab === "2" ? "tw:bg-white tw:font-semibold tw:border-b tw:border-l tw:border-[#DADADA] tw:border-t" : "tw:bg-[#F7F7F7] tw:z-[1]",
              )}
              onClick={() => setTerminal("2")}
            >
              <div
                className={cn(
                  activeTab === "2" ? "tw:text-[#282828]" : "tw:text-[#8D8D8D]"
                )}
              >
                {t("MapPage.NaritaAirport.Terminal2")}
              </div>
            </div>
            <div
              className={cn(
                "tw:flex tw:items-center tw:px-[26px] tw:cursor-pointer tw:h-[75px] tw:relative tw:rounded-bl-md",
                activeTab === "3" ? "tw:bg-white tw:font-semibold tw:border-b tw:border-l tw:border-[#DADADA] tw:border-t" : "tw:bg-[#F7F7F7] tw:z-[1]",
              )}
              onClick={() => setTerminal("3")}
            >
              <div
                className={cn(
                  activeTab === "3" ? "tw:text-[#282828]" : "tw:text-[#8D8D8D]"
                )}
              >
                {t("MapPage.NaritaAirport.Terminal3")}
              </div>
            </div>
          </div>

          <div className="tw:absolute tw:top-0 tw:bottom-0 tw:w-[1px] tw:bg-[#DADADA] tw:z-0 tw:left-[320px]" />

          {activeTab && (
            <div
              className="tw:absolute tw:w-[1px] tw:bg-white tw:z-10 tw:left-[320px] tw:h-[75px]"
              style={{
                top: `${terminals.findIndex(t => t.id === activeTab) * 75}px`
              }}
            />
          )}
          <div className="tw:flex-1 tw:bg-white tw:p-6 tw:rounded-tr-md tw:rounded-br-md tw:flex tw:items-start tw:justify-between tw:border-b tw:border-[#DADADA]">
            <div className="tw:flex-1">
              <img
                src={terminals.find(t => t.id === activeTab)?.imageUrl}
                className="tw:w-full tw:h-auto tw:object-contain"
                alt="Narita Airport Terminal 1"
              />
            </div>
            <div className="tw:min-w-[200px]">
              <a
                href={terminals.find(t => t.id === activeTab)?.imageUrl}
                download
                target="_blank"
                className={cn(
                  "tw:flex tw:items-center tw:justify-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:font-bold tw:border tw:border-[#C9C9C9D8] tw:rounded-md tw:cursor-pointer tw:!no-underline tw:!text-[#282828]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <div className="tw:w-3"><DownloadLargeIcon color="#282828" size={13} /></div>
                <div>
                  {t("MapPage.Download")}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Accordion */}
      <div className="tw:lg:hidden">
        <div className="tw:border tw:border-[#DADADA] tw:rounded-md tw:overflow-hidden">
          {/* Terminal 1 */}
          <div className={cn(activeTab === "1" && "tw:border-b tw:border-[#DADADA]")}>
            <div
              className={cn(
                "tw:flex tw:items-center tw:justify-between tw:w-full tw:px-6 tw:h-[62px] tw:cursor-pointer tw:font-semibold",
                activeTab === "1"
                  ? "tw:bg-white tw:text-[#282828]"
                  : "tw:bg-[#F7F7F7] tw:text-[#8D8D8D] tw:hover:bg-gray-200 tw:border-b tw:border-[#DADADA]"
              )}
              onClick={() => setTerminal(activeTab === "1" ? null : "1")}
            >
              <span>{t("MapPage.NaritaAirport.Terminal1")}</span>
              <svg
                className={cn(
                  "tw:w-5 tw:h-5 tw:transition-transform",
                  activeTab === "1"
                    ? "tw:text-[#8D8D8D] tw:rotate-180"
                    : "tw:text-[#8D8D8D]"
                )}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {activeTab === "1" && (
              <div className="tw:p-6 tw:bg-white tw:border-t tw:border-[#DADADA]">
                <img
                  src={terminals.find(t => t.id === "1")?.imageUrl}
                  className="tw:w-full tw:h-auto tw:object-contain tw:mb-4"
                  alt="Narita Airport Terminal 1"
                />

                <div
                  className={cn(
                    "tw:flex tw:items-center tw:justify-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:font-bold tw:border tw:border-[#DADADA] tw:rounded-md tw:cursor-pointer tw:bg-white tw:hover:bg-gray-50 tw:transition-colors",
                    getTypographyClass(13),
                    getTypographyClass(14, "lg")
                  )}
                >
                  <div>
                    <DownloadLargeIcon color="#282828" size={13} />
                  </div>
                  <div>Download</div>
                </div>
              </div>
            )}
          </div>

          {/* Terminal 2 */}
          <div>
            <div
              className={cn(
                "tw:flex tw:items-center tw:justify-between tw:w-full tw:px-6 tw:h-[62px] tw:cursor-pointer tw:font-semibold",
                activeTab === "2"
                  ? "tw:bg-white tw:text-[#282828]"
                  : "tw:bg-[#F7F7F7] tw:text-[#8D8D8D] tw:hover:bg-gray-200"
              )}
              onClick={() => setTerminal(activeTab === "2" ? null : "2")}
            >
              <span>{t("MapPage.NaritaAirport.Terminal2")}</span>
              <svg
                className={cn(
                  "tw:w-5 tw:h-5 tw:transition-transform",
                  activeTab === "2"
                    ? "tw:text-[#8D8D8D] tw:rotate-180"
                    : "tw:text-[#8D8D8D]"
                )}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {activeTab === "2" && (
              <div className="tw:p-6 tw:bg-white tw:border-t tw:border-[#DADADA]">
                <img
                  src={terminals.find(t => t.id === "2")?.imageUrl}
                  className="tw:w-full tw:h-auto tw:object-contain tw:mb-4"
                  alt="Narita Airport Terminal 2"
                />

                <a
                  href={terminals.find(t => t.id === activeTab)?.imageUrl}
                  download
                  target="_blank"
                  className={cn(
                    "tw:flex tw:items-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:font-bold tw:border tw:border-[#C9C9C9D8] tw:rounded-md tw:cursor-pointer tw:!no-underline tw:!text-[#282828] tw:justify-center",
                    getTypographyClass(13),
                    getTypographyClass(14, "lg")
                  )}
                >
                  <div className="tw:w-3"><DownloadLargeIcon color="#282828" size={13} /></div>
                  <div>
                    {t("MapPage.Download")}
                  </div>
                </a>
              </div>
            )}
          </div>

          {/* Terminal 3 */}
          <div>
            <div
              className={cn(
                "tw:flex tw:items-center tw:justify-between tw:w-full tw:px-6 tw:h-[62px] tw:cursor-pointer tw:font-semibold",
                activeTab === "3"
                  ? "tw:bg-white tw:text-[#282828]"
                  : "tw:bg-[#F7F7F7] tw:text-[#8D8D8D] tw:hover:bg-gray-200"
              )}
              onClick={() => setTerminal(activeTab === "3" ? null : "3")}
            >
              <span>{t("MapPage.NaritaAirport.Terminal3")}</span>
              <svg
                className={cn(
                  "tw:w-5 tw:h-5 tw:transition-transform",
                  activeTab === "3"
                    ? "tw:text-[#8D8D8D] tw:rotate-180"
                    : "tw:text-[#8D8D8D]"
                )}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {activeTab === "3" && (
              <div className="tw:p-6 tw:bg-white tw:border-t tw:border-[#DADADA]">
                <img
                  src={terminals.find(t => t.id === "3")?.imageUrl}
                  className="tw:w-full tw:h-auto tw:object-contain tw:mb-4"
                  alt="Narita Airport Terminal 2"
                />

                <a
                  href={terminals.find(t => t.id === activeTab)?.imageUrl}
                  download
                  target="_blank"
                  className={cn(
                    "tw:flex tw:items-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:font-bold tw:border tw:border-[#C9C9C9D8] tw:rounded-md tw:cursor-pointer tw:!no-underline tw:!text-[#282828] tw:justify-center",
                    getTypographyClass(13),
                    getTypographyClass(14, "lg")
                  )}
                >
                  <div className="tw:w-3"><DownloadLargeIcon color="#282828" size={13} /></div>
                  <div>
                    {t("MapPage.Download")}
                  </div>
                </a>
              </div>
            )}
          </div>

          {/* Terminal 3 */}
          <div>
            <div
              className={cn(
                "tw:flex tw:items-center tw:justify-between tw:w-full tw:px-6 tw:h-[62px] tw:cursor-pointer tw:font-semibold",
                activeTab === "Terminal3"
                  ? "tw:bg-white tw:text-[#282828]"
                  : "tw:bg-[#F7F7F7] tw:text-[#8D8D8D] tw:hover:bg-gray-200"
              )}
              onClick={() => setActiveTab(activeTab === "Terminal3" ? null : "Terminal3")}
            >
              <span>{t("MapPage.NaritaAirport.Terminal3")}</span>
              <svg
                className={cn(
                  "tw:w-5 tw:h-5 tw:transition-transform",
                  activeTab === "Terminal3"
                    ? "tw:text-[#8D8D8D] tw:rotate-180"
                    : "tw:text-[#8D8D8D]"
                )}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {activeTab === "Terminal3" && (
              <div className="tw:p-6 tw:bg-white tw:border-t tw:border-[#DADADA]">
                <img
                  src={terminals.find(t => t.id === "Terminal3")?.imageUrl}
                  className="tw:w-full tw:h-auto tw:object-contain tw:mb-4"
                  alt="Narita Airport Terminal 2"
                />

                <a href={terminals.find(t => t.id === activeTab)?.imageUrl} download target="_blank" className="tw:flex tw:items-center tw:gap-3 tw:px-[18px] tw:h-[44px] tw:text-sm tw:font-bold tw:border tw:border-[#C9C9C9D8] tw:rounded-md tw:cursor-pointer tw:!no-underline tw:!text-[#282828] tw:justify-center">
                  <div className="tw:w-3"><DownloadLargeIcon color="#282828" size={13} /></div>
                  <div>
                    {t("MapPage.Download")}
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};